import { ReactElement } from 'react';
import Sticky from 'react-sticky-el';
import { Props as ReactStickyProps } from 'react-sticky-el/lib/basic-version';

/**
 * Avoid an error message from react-sticky-el when scrollElement is not provided
 */
export const StickyGuard = (
  props: Partial<ReactStickyProps> & {
    children: ReactElement;
  },
): JSX.Element => {
  const { children, scrollElement, ...rest } = props;

  if (!scrollElement) {
    return children;
  }

  return (
    <Sticky scrollElement={scrollElement} {...rest}>
      {children}
    </Sticky>
  );
};
